import "./App.css";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/urbanist";

import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import Footer from "./components/Footer";
import Header from "./components/Header";
import CouponPage from "./components/CouponPage";
import FormPage from "./components/FormPage";
import SuccessPage from "./components/SuccessPage";
import ErrorPage from "./components/ErrorPage";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { CouponContextProvider } from "./contexts/couponContext";
import { useEffect } from "react";
import TagManager from "react-gtm-module";

// Componente para rastrear mudanças de rota
const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const pagePath = location.pathname + location.search;
    TagManager.dataLayer({
      dataLayer: {
        event: "pageview",
        pagePath: pagePath,
      },
    });
    console.log(`Pageview enviado: ${pagePath}`);
  }, [location]);

  return null;
};

function App() {
  return (
    <div className="App">
      <Header />
      <CouponContextProvider>
        <ErrorBoundary>
          <HashRouter>
            <RouteChangeTracker /> {/* Adiciona o monitor de rota */}
            <Routes>
              <Route path="/" element={<CouponPage />} />
              <Route path="coupon/:couponId" element={<CouponPage />} />
              <Route path="/form" element={<FormPage />} />
              <Route path="/success" element={<SuccessPage />} />
              <Route path="*" element={<ErrorPage />} />
            </Routes>
          </HashRouter>
        </ErrorBoundary>
      </CouponContextProvider>
      <Footer />
    </div>
  );
}

export default App;
